<template>
  <div class="navigation-title-section">
    <div class="navigation-title-section-content">IDs export</div>
  </div>
  <div class="row p-1">
    <p>
      Download this CSV to view all CERES database IDs that you need for bulk
      upload of Artworks.
    </p>
    <el-button @click="exportData" class="button_style_1"
      >Download CSV
    </el-button>
  </div>
</template>

<script>
import { excelParser } from "@/helpers/excele-parser";
import axios from "axios";
import { ElNotification } from "element-plus";
export default {
  name: "CategoryExport",
  components: {},
  data() {
    return {
      json_data: [],
    };
  },
  mounted() {
    this.fetchData().then((res) => {
      this.json_data = res.data;
    });
  },
  methods: {
    exportData() {
      try {
        excelParser().exportDataFromJSON(this.json_data, "categories", "csv");
      } catch (error) {
        ElNotification({
          title: "Error!",
          message: error,
          type: "error",
        });
      }
    },
    async fetchData() {
      return await axios
        .get(`${process.env.VUE_APP_SHARED_API}api/bulk-export/categories`, {
          headers: {
            Authorization: `Bearer ${this.$cookies.get("bearerToken")}`,
          },
        })
        .then((res) => {
          return res;
        })
        .catch((error) => {
          ElNotification({
            title: "Error!",
            message: error,
            type: "error",
          });
        });
    },
  },
};
</script>
<style scoped>
.button_style_1 {
  max-width: 350px !important;
}
</style>
